import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Supported languages
const languages = ["en", "es", "ru", "zh"];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: languages,
    debug: false,

    detection: {
      // We DO NOT detect language from URL path to avoid conflicts like /whitepaper
      order: ["localStorage", "navigator", "htmlTag", "cookie"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng"
    },

    interpolation: {
      escapeValue: false
    },

    backend: {
      loadPath: "/i18n/{{lng}}.json"
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;
